/* Vermiviva v3: herramientas propias (sin librerias) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var DIA = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  function fmtCorto(d) { return d.getDate() + ' ' + MES[d.getMonth()]; }
  function fmtLargo(d) { return DIA[d.getDay()] + ' ' + d.getDate() + ' ' + MES[d.getMonth()]; }
  function sumaDias(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); return x; }
  function sumaHabiles(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function iso(d) { var m = d.getMonth() + 1, dd = d.getDate(); return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dd < 10 ? '0' : '') + dd; }
  function deIso(s) { var p = (s || '').split('-'); return p.length === 3 ? new Date(+p[0], +p[1] - 1, +p[2]) : null; }
  function coma(n, dec) { return n.toFixed(dec).replace('.', ','); }

  /* 1. Fecha de entrega en vivo */
  var hoy = new Date();
  var llegaDesde = sumaHabiles(hoy, 2), llegaHasta = sumaHabiles(hoy, 4);
  $$('[data-vz-entrega-txt]').forEach(function (el) {
    el.textContent = 'llega entre el ' + fmtLargo(llegaDesde) + ' y el ' + fmtLargo(llegaHasta);
  });
  var mesNum = hoy.getMonth() + 1;
  if (mesNum >= 6 && mesNum <= 9) {
    $$('[data-vz-entrega]').forEach(function (el) {
      var s = document.createElement('small'); s.className = 'vz-calor';
      s.textContent = 'En verano, si hace más de 30 °C, acordamos contigo el día de salida para que viajen bien.';
      el.appendChild(s);
    });
  }

  /* 2. Chat: las respuestas de Rosi aparecen una a una */
  var chat = $('[data-vz-chat]');
  if (chat && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var par = e.target; io.unobserve(par);
        par.classList.add('is-q');
        setTimeout(function () { par.classList.add('is-a'); }, 650);
      });
    }, { threshold: 0.45 });
    $$('.vz-chat__par', chat).forEach(function (p) { io.observe(p); });
  } else if (chat) {
    $$('.vz-chat__par', chat).forEach(function (p) { p.classList.add('is-q', 'is-a'); });
  }

  /* 3. Dibujo con puntos */
  var hot = $('[data-vz-hot]');
  if (hot) {
    var items = $$('.vz-piezas li');
    var zonas = $$('[data-vz-zona]', hot);
    var pts = $$('.vz-punto', hot);
    var activar = function (n) {
      items.forEach(function (li) { li.classList.toggle('is-on', li.getAttribute('data-vz-i') === n); });
      pts.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-vz-p') === n); });
      zonas.forEach(function (z) { z.classList.toggle('is-dim', !!n && z.getAttribute('data-vz-zona') !== n); });
    };
    pts.forEach(function (b) {
      var n = b.getAttribute('data-vz-p');
      b.addEventListener('click', function () { activar(n); });
      b.addEventListener('mouseenter', function () { activar(n); });
      b.addEventListener('focus', function () { activar(n); });
    });
    items.forEach(function (li) {
      var n = li.getAttribute('data-vz-i');
      li.addEventListener('mouseenter', function () { activar(n); });
      li.addEventListener('click', function () { activar(n); });
    });
    hot.addEventListener('mouseleave', function () { activar(''); });
    activar('1');
  }

  /* 4. Calculadora */
  var calc = $('[data-vz-calc]');
  if (calc) {
    var rng = $('input[type=range]', calc), outP = $('[data-vz-pers]', calc);
    var kg = $('[data-vz-kg]', calc), sem2 = $('[data-vz-sem2]', calc), sem = $('[data-vz-sem]', calc), anio = $('[data-vz-anio]', calc), msg = $('[data-vz-msg]', calc);
    var CAP_KIT = 0.4;   /* kg/semana que come un kit de 250 al empezar */
    var CAP_CAJA = 1.6;  /* kg/semana que maneja una caja normal ya poblada */
    var DOBLA = 8;       /* semanas aprox. para duplicarse (45-60 dias, La Tercera) */
    var pinta = function () {
      var p = +rng.value, f = +($('input[name=vz-cant]:checked', calc) || { value: 0.5 }).value;
      var need = p * f;
      outP.textContent = p;
      kg.textContent = coma(need, 1);
      var s = need <= CAP_KIT ? 0 : Math.ceil(Math.log(need / CAP_KIT) / Math.LN2 * DOBLA);
      sem.textContent = s === 0 ? '0' : s;
      anio.textContent = Math.round(Math.min(need, CAP_CAJA) * 52);
      var s2 = need <= CAP_KIT * 2 ? 0 : Math.ceil(Math.log(need / (CAP_KIT * 2)) / Math.LN2 * DOBLA);
      if (sem2) sem2.textContent = s2;
      msg.textContent = need <= CAP_KIT ? 'Con un kit vas sobrado desde el primer día.'
        : need <= CAP_KIT * 2 ? 'Un kit es un buen comienzo: empiezan despacio, se multiplican y en pocas semanas se comen todo lo que echas.'
        : 'Con 2 kits empiezas con el doble de lombrices, llegas antes a tu ritmo y el envío sale gratis.';
    };
    calc.addEventListener('input', pinta); calc.addEventListener('change', pinta); pinta();
  }

  /* 5. Primer mes + recordatorios .ics */
  var mes = $('[data-vz-mes]');
  if (mes) {
    var ETAPAS = [
      { ini: 0, fin: 0,
        haz: ['Abre la caja y deja las lombrices sobre el sustrato de tu caja ya preparada (cartón húmedo y sustrato).', 'Enciende una luz encima unas horas: huyen de ella y se meten hacia abajo.', 'No les eches comida hoy. Déjalas instalarse 24 horas.'],
        veras: ['Se esconderán enseguida. Es lo normal.', 'Alguna se paseará un rato por la superficie: no pasa nada.'] },
      { ini: 1, fin: 7,
        haz: ['Echa un puñado pequeño de restos troceados en un rincón y tápalo con cartón.', 'Comprueba la humedad: tiene que parecer una esponja escurrida.', 'No añadas más hasta que el puñado haya desaparecido.'],
        veras: ['La comida se va reblandeciendo y oscureciendo.', 'Huele a tierra mojada, no a podrido.'] },
      { ini: 8, fin: 14,
        haz: ['Cambia de rincón en cada comida.', 'Si ves moscas pequeñas: más cartón por encima y menos comida.', 'Mantén la caja entre 15 y 25 °C y sin sol directo.'],
        veras: ['Los restos desaparecen en pocos días.', 'Más lombrices cerca de donde echaste la última comida.'] },
      { ini: 15, fin: 28,
        haz: ['Sube la ración poco a poco, solo si todo lo anterior se ha comido.', 'Añade cartón nuevo cuando el de arriba esté deshecho.', 'Cada pocos días, remueve suave con la mano o un tenedor.'],
        veras: ['Lombrices pequeñas y finas: son las crías.', 'Bolitas diminutas de color miel: son los huevos.'] },
      { ini: 29, fin: 150,
        haz: ['Mantén el ritmo y sigue sumando restos y cartón.', 'Cuando el fondo sea tierra oscura y suelta, empieza a apartar humus por un lado.', 'Usa el humus mezclado con tierra de tus macetas.'],
        veras: ['El fondo cambia a tierra oscura, suave y sin olor fuerte.', 'Cada vez más lombrices: la caja trabaja casi sola.'] }
    ];
    var inp = $('[data-vz-llegada]', mes), tabs = $$('[data-vz-t]', mes);
    var ulH = $('[data-vz-haz]', mes), ulV = $('[data-vz-veras]', mes);
    var base = new Date(llegaDesde);
    inp.value = iso(base);
    var lis = function (ul, arr) { ul.innerHTML = ''; arr.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); }); };
    var fechas = function () {
      var a = deIso(inp.value) || base;
      ETAPAS.forEach(function (e, i) {
        var d1 = sumaDias(a, e.ini), d2 = sumaDias(a, e.fin);
        var el = $('[data-vz-d="' + i + '"]', mes);
        if (el) el.textContent = e.ini === e.fin ? fmtCorto(d1) : (i === 4 ? 'desde el ' + fmtCorto(d1) : fmtCorto(d1) + ' – ' + fmtCorto(d2));
      });
    };
    var ver = function (i) {
      tabs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      lis(ulH, ETAPAS[i].haz); lis(ulV, ETAPAS[i].veras);
    };
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { ver(i); }); });
    inp.addEventListener('change', fechas);
    fechas(); ver(0);

    var AVISOS = [
      [0, 'Día 0: instala a las lombrices', 'Deja las lombrices sobre el sustrato de tu caja preparada, enciende una luz encima unas horas y no les des comida hoy.'],
      [1, 'Primera comida pequeña', 'Un puñado pequeño de restos troceados en un rincón, tapado con cartón.'],
      [7, 'Revisión de la semana 1', 'Mira si el puñado ha desaparecido y si la humedad es la de una esponja escurrida. Si no se ha comido, no añadas más.'],
      [14, 'Revisión de la semana 2', 'Cambia de rincón. Si hay moscas pequeñas: más cartón y menos comida.'],
      [21, 'Semana 3: sube la ración', 'Sube un poco la cantidad solo si todo lo anterior se ha comido. Añade cartón nuevo.'],
      [28, 'Un mes: busca a las crías', 'Busca lombrices pequeñas y finas y bolitas color miel. Son crías y huevos.'],
      [90, 'Mira el fondo: humus', 'Si el fondo es tierra oscura y suelta, ya puedes apartar el primer humus.']
    ];
    var esc = function (t) { return t.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n'); };
    var cmp = function (d) { return iso(d).replace(/-/g, ''); };
    $('[data-vz-ics]', mes).addEventListener('click', function () {
      var a = deIso(inp.value) || base, st = new Date();
      var sello = st.getUTCFullYear() + ('0' + (st.getUTCMonth() + 1)).slice(-2) + ('0' + st.getUTCDate()).slice(-2) + 'T' + ('0' + st.getUTCHours()).slice(-2) + ('0' + st.getUTCMinutes()).slice(-2) + '00Z';
      var L = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Vermiviva//Primer mes//ES', 'CALSCALE:GREGORIAN'];
      AVISOS.forEach(function (v, i) {
        var d = sumaDias(a, v[0]);
        L.push('BEGIN:VEVENT', 'UID:vermiviva-' + cmp(a) + '-' + i + '@vermiviva', 'DTSTAMP:' + sello,
          'DTSTART;VALUE=DATE:' + cmp(d), 'DTEND;VALUE=DATE:' + cmp(sumaDias(d, 1)),
          'SUMMARY:' + esc('Vermiviva · ' + v[1]), 'DESCRIPTION:' + esc(v[2]),
          'BEGIN:VALARM', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(v[1]), 'TRIGGER;RELATED=START:PT9H', 'END:VALARM', 'END:VEVENT');
      });
      L.push('END:VCALENDAR');
      var blob = new Blob([L.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
      var url = URL.createObjectURL(blob), link = document.createElement('a');
      link.href = url; link.download = 'vermiviva-primer-mes.ics';
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
    });
  }

  /* 6. ¿Puedo echar...? */
  var pz = $('[data-vz-puedo]');
  if (pz) {
    var S = 'si', O = 'ojo', N = 'no';
    var DATOS = [
      [['platano', 'banana', 'cascara de platano'], S, 'Plátano', 'La fruta pasada la comen rápido. La cáscara es más lenta: en trozos pequeños vale muy bien.', 'Fruta pasada: de unos días a 1 semana. Cáscara: 2 a 4 semanas'],
      [['manzana', 'pera', 'melocoton', 'ciruela', 'fruta', 'fresa', 'uva', 'cereza'], S, 'Fruta', 'Troceada y sin pegatinas. Si es muy azucarada y no la entierras, puede atraer moscas.', 'Unos días a 1 semana (fruta blanda)'],
      [['melon', 'sandia'], S, 'Melón y sandía', 'De las favoritas, pero llevan mucha agua: échalo con cartón seco para no encharcar.', 'Unos días a 1 semana'],
      [['zanahoria', 'calabacin', 'calabaza', 'remolacha', 'pepino', 'judias', 'guisantes', 'esparrago'], S, 'Verdura', 'En trozos pequeños, o congelada antes: se ablanda y desaparece antes.', 'Blanda: unos días a 1 semana. Dura y cruda: 2 a 4 semanas'],
      [['lechuga', 'espinaca', 'acelga', 'verdura', 'hortaliza'], S, 'Hojas verdes', 'Blandas y fáciles. Si van muy mojadas, mezcla con cartón.', 'Unos días a 1 semana'],
      [['brocoli', 'coliflor', 'col', 'repollo'], O, 'Brócoli, coliflor y col', 'Poca cantidad: huelen más al pudrirse. Los tallos son lentos y sirven de comida de liberación lenta.', 'Tallos: 2 a 4 semanas'],
      [['pimiento'], O, 'Pimiento', 'El dulce, en poca cantidad. El picante, no.', null],
      [['patata', 'peladura'], O, 'Patata', 'Las peladuras crudas son lentas y a veces quedan sin comer. Mejor cocidas o congeladas antes. Nunca la piel verde.', null],
      [['cafe', 'posos', 'filtro de cafe'], S, 'Posos de café', 'Mezclados, como mucho una quinta parte de lo que echas, y no en una capa gruesa. El filtro de papel vale como cama.', '1 a 2 semanas'],
      [['te', 'infusion', 'manzanilla', 'bolsita'], S, 'Té e infusiones', 'Las hojas, sí. Abre la bolsita: muchas llevan plástico.', '1 a 2 semanas'],
      [['cascara de huevo', 'cascaras de huevo', 'huevo'], O, 'Huevo', 'La cáscara, lavada, seca y triturada muy fina, es de lo mejor: aporta grano y calma la acidez. El huevo entero o cocinado, muy poco.', 'Cáscara: sin plazo publicado, por eso se tritura en polvo'],
      [['carton', 'papel', 'servilleta', 'hojas secas', 'hoja seca', 'serrin', 'periodico'], S, 'Cartón y papel', 'Es la cama y la manta: sin brillo, sin cinta ni etiquetas de plástico, rasgado y húmedo. Cuenta como cama, no como comida.', 'Despacio: en torno a un mes la caja ya suele estar más vacía'],
      [['cesped', 'flores', 'flor', 'planta', 'hierba'], O, 'Césped y plantas', 'Capa fina y seca: si no, fermenta y calienta. Nunca de césped tratado.', null],
      [['naranja', 'mandarina', 'limon', 'pomelo', 'citrico', 'lima'], O, 'Cítricos', 'Muy poca cantidad y enterrado: son ácidos. En una caja pequeña, mejor no echarlos.', null],
      [['cebolla', 'ajo', 'puerro', 'cebolleta'], O, 'Cebolla, ajo y puerro', 'Las guías no se ponen de acuerdo: unas dicen que no pasa nada y otras que mejor evitarlos. Lo prudente es muy poca cantidad, picada y enterrada.', null],
      [['tomate'], O, 'Tomate', 'Con moderación: es ácido y lleva mucha agua.', null],
      [['pina', 'kiwi'], O, 'Piña y kiwi', 'Ácidos: muy poca cantidad.', null],
      [['pan', 'arroz', 'pasta', 'cereal', 'harina'], O, 'Pan, arroz y pasta', 'Muy poco, mojado y enterrado, sin salsa ni aceite. Se apelmazan y atraen moscas.', null],
      [['aguacate'], O, 'Aguacate', 'La pulpa pasada y la piel, en poca cantidad. El hueso no se descompone en la caja.', 'Hueso: muchísimo tiempo'],
      [['nuez', 'almendra', 'cascara dura', 'frutos secos', 'mazorca', 'hueso de fruta'], O, 'Cosas duras', 'Muy lentas: triturado y sin sal, o mejor no.', 'Mazorca de maíz y huesos: varios meses'],
      [['picante', 'chile', 'guindilla'], N, 'Picante', 'No: unas guías lo permiten y otras no. Por si acaso, fuera.'],
      [['carne', 'pollo', 'cerdo', 'ternera', 'jamon', 'embutido', 'chorizo'], N, 'Carne', 'No. Se pudre, huele y atrae moscas y roedores.'],
      [['pescado', 'marisco', 'atun', 'gamba', 'sardina'], N, 'Pescado y marisco', 'No. Huele muy fuerte y atrae moscas.'],
      [['hueso', 'espina'], N, 'Huesos y espinas', 'No: tardan meses y atraen bichos.'],
      [['queso', 'leche', 'yogur', 'mantequilla', 'nata', 'lacteo', 'helado'], N, 'Lácteos', 'No. Se pudren pronto y huelen mal.'],
      [['aceite', 'frito', 'grasa', 'salsa', 'mayonesa', 'vinagre'], N, 'Aceites y grasas', 'No. Ahogan a las lombrices y huelen.'],
      [['sal', 'azucar', 'dulce', 'bolleria', 'galleta', 'chocolate', 'pastel', 'comida cocinada', 'sobras cocinadas'], N, 'Comida procesada', 'No: lleva sal, azúcar o grasa y estropea la caja.'],
      [['mascota', 'perro', 'gato', 'excremento', 'arena de gato', 'caca'], N, 'Heces de mascotas', 'No. Pueden llevar patógenos.'],
      [['ceniza', 'carbon', 'colilla', 'tabaco'], N, 'Ceniza y colillas', 'No: dañan a las lombrices.'],
      [['plastico', 'bolsa', 'revista', 'papel brillante', 'ticket', 'chicle', 'aspiradora', 'polvo'], N, 'Plástico y papel brillante', 'No: no se descompone o lleva tintas y químicos.']
    ];
    var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim(); };
    var DATN = DATOS.map(function (d) { return { k: d[0].map(norm), v: d[1], n: d[2], t: d[3], d: d[4] }; });
    var tiempo = $('[data-vz-tiempo]', pz), inpC = $('[data-vz-comida]', pz), box = $('[data-vz-ver]', pz), sello = $('[data-vz-sello]', pz), nom = $('[data-vz-nombre]', pz), nota = $('[data-vz-nota]', pz), chips = $('[data-vz-chips]', pz);
    var ETQ = { si: ['✓', 'Sí', 'vz-sello--si'], ojo: ['!', 'Con cuidado', 'vz-sello--ojo'], no: ['✕', 'No', 'vz-sello--no'] };
    var busca = function (q) {
      q = norm(q); if (q.length < 2) return null;
      var best = null;
      DATN.forEach(function (d) { d.k.forEach(function (k) {
        if (k === q) { best = best && best.exact ? best : { d: d, exact: true }; }
        else if (!best && (k.indexOf(q) === 0 || (q.length >= 3 && q.indexOf(k) !== -1 && k.length >= 3) || (q.length >= 3 && k.indexOf(q) !== -1))) { best = { d: d, exact: false }; }
      }); });
      return best && best.d;
    };
    var muestra = function (d, texto) {
      box.hidden = false;
      var e = d ? ETQ[d.v] : ['?', 'No lo tengo', 'vz-sello--ojo'];
      sello.className = 'vz-sello ' + e[2]; sello.textContent = e[0];
      nom.textContent = d ? e[1] + ' · ' + d.n : e[1] + ' apuntado';
      var td = !d ? 'Sin dato' : d.v === 'no' ? 'No se lo comen: se pudre y estropea la caja' : (d.d || 'Sin plazo publicado: ninguna guía da un tiempo. Echa poco y espera a que desaparezca');
      tiempo.textContent = td;
      nota.textContent = d ? d.t : 'Regla general: restos de fruta y verdura sí; carne, lácteos, aceite y comida cocinada, no. Escríbenos y lo miramos.';
    };
    inpC.addEventListener('input', function () {
      var q = inpC.value;
      if (norm(q).length < 2) { box.hidden = true; return; }
      muestra(busca(q));
    });
    ['plátano', 'café', 'cebolla', 'naranja', 'pan', 'queso', 'carne', 'cáscara de huevo'].forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = t;
      b.addEventListener('click', function () { inpC.value = t; muestra(busca(t)); });
      chips.appendChild(b);
    });
  }

  /* 7. Selector de 1 o 2 kits junto a la compra */
  var form = $('#vv-form-kit');
  if (form) {
    var qty = $('input[name=quantity]', form), radios = $$('input[name=vz-pack]', form);
    var marca = function () {
      var v = (+qty.value || 1) >= 2 ? '2' : '1';
      radios.forEach(function (r) { r.checked = r.value === v; r.parentNode.classList.toggle('is-on', r.checked); });
    };
    radios.forEach(function (r) { r.addEventListener('change', function () { qty.value = r.value; marca(); }); });
    qty.addEventListener('input', marca); qty.addEventListener('change', marca);
    form.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-q]')) setTimeout(marca, 30); });
    marca();
  }

  /* 8. Las lombrices de la portada solo se animan mientras se ven */
  var suelo = $('.vz-suelo');
  if (suelo && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        $$('.vz-lombriz', suelo).forEach(function (w) { w.style.animationPlayState = e.isIntersecting ? 'running' : 'paused'; });
      });
    }, { threshold: 0.05 }).observe(suelo);
  }
})();
